const articles = [
    {
        name: 'horizontal-vertical',
        title: 'Create Horizonatal and Vertical Control Points',
        content: [
            `Welcome! Today we're going to be talking about the fastest way to
            create Create Horizonatal and Vertical Control Points. We'll be discussing some topics such as proin congue
            ligula id risus posuere, vel eleifend ex egestas. Sed in turpis leo. 
            Aliquam malesuada in massa tincidunt egestas.`,
        ]
    }//,    {
    //     name: 'ocpw-gps',
    //     title: 'GPS Points Across Orange County',
    //     content: [
    //         `In this article, we're going to be talking looking at a very quick way
    //         to set up a GPS Points Across Orange County. We'll be discussing some topics such as proin congue
    //         ligula id risus posuere, vel eleifend ex egestas. Sed in turpis leo. 
    //         Aliquam malesuada in massa tincidunt egestas. Nam consectetur varius turpis, 
    //         non porta arcu porttitor non. In tincidunt vulputate nulla quis egestas. Ut 
    //         eleifend ut ipsum non fringilla. Praesent imperdiet nulla nec est luctus, at 
    //         sodales purus euismod.`,
    //         `Donec vel mauris lectus. Etiam nec lectus urna. Sed sodales ultrices dapibus. 
    //         Nam blandit tristique risus, eget accumsan nisl interdum eu. Aenean ac accumsan 
    //         nisi. Nunc vel pulvinar diam. Nam eleifend egestas viverra. Donec finibus lectus 
    //         sed lorem ultricies, eget ornare leo luctus. Morbi vehicula, nulla eu tempor 
    //         interdum, nibh elit congue tellus, ac vulputate urna lorem nec nisi. Morbi id 
    //         consequat quam. Vivamus accumsan dui in facilisis aliquet.`,
    //         `Etiam nec lectus urna. Sed sodales ultrices dapibus. 
    //         Nam blandit tristique risus, eget accumsan nisl interdum eu. Aenean ac accumsan 
    //         nisi. Nunc vel pulvinar diam. Nam eleifend egestas viverra. Donec finibus lectus 
    //         sed lorem ultricies, eget ornare leo luctus. Morbi vehicula, nulla eu tempor 
    //         interdum, nibh elit congue tellus, ac vulputate urna lorem nec nisi. Morbi id 
    //         consequat quam. Vivamus accumsan dui in facilisis aliquet.`,
    //     ]
    // },     {
    //     name: 'city-ties',
    //     title: 'City Ties',
    //     content: [
    //         `Today is the day I talk about something which scares most people: City Ties.
    //         In reality, I'm not sure why people have such a hard time with proin congue
    //         ligula id risus posuere, vel eleifend ex egestas. Sed in turpis leo. 
    //         Aliquam malesuada in massa tincidunt egestas. Nam consectetur varius turpis, 
    //         non porta arcu porttitor non. In tincidunt vulputate nulla quis egestas. Ut 
    //         eleifend ut ipsum non fringilla. Praesent imperdiet nulla nec est luctus, at 
    //         sodales purus euismod.`,
    //         `Donec vel mauris lectus. Etiam nec lectus urna. Sed sodales ultrices dapibus. 
    //         Nam blandit tristique risus, eget accumsan nisl interdum eu. Aenean ac accumsan 
    //         nisi. Nunc vel pulvinar diam. Nam eleifend egestas viverra. Donec finibus lectus 
    //         sed lorem ultricies, eget ornare leo luctus. Morbi vehicula, nulla eu tempor 
    //         interdum, nibh elit congue tellus, ac vulputate urna lorem nec nisi. Morbi id 
    //         consequat quam. Vivamus accumsan dui in facilisis aliquet.`,
    //         `Etiam nec lectus urna. Sed sodales ultrices dapibus. 
    //         Nam blandit tristique risus, eget accumsan nisl interdum eu. Aenean ac accumsan 
    //         nisi. Nunc vel pulvinar diam. Nam eleifend egestas viverra. Donec finibus lectus 
    //         sed lorem ultricies, eget ornare leo luctus. Morbi vehicula, nulla eu tempor 
    //         interdum, nibh elit congue tellus, ac vulputate urna lorem nec nisi. Morbi id 
    //         consequat quam. Vivamus accumsan dui in facilisis aliquet.`,
    //     ]
    // },  
];

export default articles;